import React, { useMemo } from "react";
import useRouteUtils from "../../utils/hooks/useRouteUtils";
import { useSelector } from "react-redux";

const useProducts = () => {
  const { checkIfActiveRoute } = useRouteUtils();
  const globalState = useSelector((state) => state.global);
  const drawerMenu = [
    {
      title: "Products",
      link: "/store/product",
      icon: (
        <span className="material-symbols-outlined x4">
          {" "}
          person_raised_hand{" "}
        </span>
      ),
      active: checkIfActiveRoute("/store/product", true),
    },
  ];
  const drawerMenuPermission = useMemo(() => {
    let menus = Object.values(
      globalState.dashboard_permissions?.menu_permissions ?? []
    )?.flatMap?.(
      (menu) =>
        menu?.sub_menu_permissions?.map((side_menu) => side_menu?.sub_menu_name)

      // menu.menu_name,
      // menu.name,
      // ...menu.permissions?.map((side_menu) => side_menu.name),
    );
    return drawerMenu
      ?.filter((menu) => {
        return menus?.includes?.(menu?.title);
      })
      ?.map((menu) => {
        return {
          ...menu,
        };
      });
    //eslint-disable-next-line
  }, [globalState.dashboard_permissions, location.pathname]);

  return { drawerMenu: drawerMenuPermission };
};

export default useProducts;
